import { LiveFeed, LiveFeedInfo, StreamingPlatform } from "./live-feed";
import { Subject } from "rxjs";

export abstract class LiveFeedRepository {
  liveFeedCreated: Subject<LiveFeedInfo>;
  liveFeedUpdated: Subject<LiveFeedInfo>;

  isStreamIdAvailable: (streamId: string) => Promise<boolean>;
  isFeedIdAvailable: (feedId: string) => Promise<boolean>;

  updateLiveFeed: (
    liveFeed: LiveFeedInfo,
  ) => Promise<{ availabilityZoneIps: { az: number; ip: string }[] }>;

  createLiveFeed: (
    liveFeed: LiveFeedInfo,
  ) => Promise<{ availabilityZoneIps: { az: number; ip: string }[] }>;

  getLiveFeeds: (nameFilter?: string) => Promise<LiveFeed[]>;

  getLiveFeedInfo: (id: string) => Promise<LiveFeedInfo>;

  deleteLiveFeed: (id: string) => Promise<void>;

  updateThumbnail: (id: string, thumbnail: string) => Promise<void>;
  getAllStreamingPlatforms: () => Promise<StreamingPlatform[]>;

  pingLiveFeedPreview: (previewFeedId: string) => void;
}
